import { useState, useRef, useMemo } from 'react';
import Controls from "./controls"
import DisplayTrack from "./displayTrack"
import ProgressBar from "./progressBar"

function AudioPlayer ({ currentSongSelection, setCurrentSongSelection, playerPlayList }) {
    const audioRef = useRef();
    const progressBarRef = useRef();
    const [songProgress, setSongProgress] = useState(0);
    const [songDuration, setSongDuration] = useState(0);
    const trackIndex = useMemo(() => playerPlayList.findIndex(track => track.key === currentSongSelection), [playerPlayList, currentSongSelection]);
    const currentTrack = useMemo(() => (playerPlayList[trackIndex]), [playerPlayList, trackIndex]);
    const totalTracks = playerPlayList.length;

    const getDuration = () => {
        const seconds = audioRef.current.duration;
        setSongDuration(seconds);
        audioRef.current.max = seconds;
    }

    const handleEnd = () => {
        if (trackIndex < totalTracks - 1) {
            setCurrentSongSelection(currentTrack.key);
        }

        var playPromise = audioRef.current.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                audioRef.current.pause();
            })
            .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            });
        }
    };

    function formatDateToYYYYMMDD(inputDate) {
        const parsedDate = new Date(inputDate); // Parse the input date
        const year = parsedDate.getFullYear();
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = parsedDate.getDate().toString().padStart(2, '0');
      
        return `${year}${month}${day}`;
      }

    return (
        <div className="player">
            <DisplayTrack {...{ currentTrack, trackIndex }} />
            <Controls {...{ audioRef, totalTracks, currentTrack, setCurrentSongSelection, progressBarRef, songDuration, setSongProgress }} />
            <ProgressBar {...{ audioRef, progressBarRef, songProgress, songDuration }} />
            <div className="audio-player">
                <audio ref={ audioRef } src={`http://www.dangblastedcranks.com/images/audio/mrkii/${formatDateToYYYYMMDD(currentTrack.session)}/${currentTrack.filename}`} onLoadedMetadata={getDuration} onEnded={handleEnd} />
            </div>
        </div>
    )
}

export default AudioPlayer